<nav class="nav">
  <div class="inner">
    <a routerLink="/" (click)="closeMenu()" class="brand">Wesele Live</a>
    <div class="right">
      <div class="wl-nav-links links">
        @for (link of links; track link.fragment) {
          <a routerLink="/" [fragment]="link.fragment">{{ link.label }}</a>
        }
      </div>
      @if (user() === null) {
        <button (click)="openLogin()" class="login-btn">Zaloguj się</button>
      }
      <button class="wl-hamburger burger" (click)="toggleMenu()" [attr.aria-expanded]="menuOpen()" aria-label="Menu">
        @if (menuOpen()) {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
        } @else {
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
        }
      </button>
    </div>
  </div>

  <!-- MOBILE MENU -->
  @if (menuOpen()) {
    <div class="wl-mobile-menu mobile">
      @for (link of links; track link.fragment) {
        <a routerLink="/" [fragment]="link.fragment" (click)="closeMenu()">{{ link.label }}</a>
      }
    </div>
  }
</nav>
